
import { WorldCity } from '../types';

// Expansión de Portugal - 60 ciudades adicionales
export const portugalAdditionalCities: WorldCity[] = [
  { name: 'Sintra', slug: 'sintra', population: 377835 },
  { name: 'Vila Nova de Gaia', slug: 'vila-nova-de-gaia', population: 302295 },
  { name: 'Loures', slug: 'loures', population: 205054 },
  { name: 'Cascais', slug: 'cascais', population: 206479 },
  { name: 'Matosinhos', slug: 'matosinhos', population: 175478 },
  { name: 'Gondomar', slug: 'gondomar', population: 168027 },
  { name: 'Vila do Conde', slug: 'vila-do-conde', population: 79533 },
  { name: 'Maia', slug: 'maia', population: 135306 },
  { name: 'Valongo', slug: 'valongo', population: 93858 },
  { name: 'Paredes', slug: 'paredes', population: 86854 },
  { name: 'Póvoa de Varzim', slug: 'povoa-de-varzim', population: 63408 },
  { name: 'Felgueiras', slug: 'felgueiras', population: 58065 },
  { name: 'Santo Tirso', slug: 'santo-tirso', population: 71530 },
  { name: 'Paços de Ferreira', slug: 'pacos-de-ferreira', population: 56340 },
  { name: 'Lousada', slug: 'lousada', population: 47387 },
  { name: 'Penafiel', slug: 'penafiel', population: 72265 },
  { name: 'Trofa', slug: 'trofa', population: 38999 },
  { name: 'Marco de Canaveses', slug: 'marco-de-canaveses', population: 53450 },
  { name: 'Amarante', slug: 'amarante', population: 56264 },
  { name: 'Baião', slug: 'baiao', population: 20522 },
  { name: 'Celorico de Basto', slug: 'celorico-de-basto', population: 20098 },
  { name: 'Cinfães', slug: 'cinfaes', population: 20427 },
  { name: 'Resende', slug: 'resende', population: 11364 },
  { name: 'Castelo de Paiva', slug: 'castelo-de-paiva', population: 16715 },
  { name: 'Arouca', slug: 'arouca', population: 22359 },
  { name: 'Santa Maria da Feira', slug: 'santa-maria-da-feira', population: 139309 },
  { name: 'São João da Madeira', slug: 'sao-joao-da-madeira', population: 21713 },
  { name: 'Oliveira de Azeméis', slug: 'oliveira-de-azemeis', population: 68611 },
  { name: 'Estarreja', slug: 'estarreja', population: 26997 },
  { name: 'Murtosa', slug: 'murtosa', population: 10585 },
  { name: 'Ovar', slug: 'ovar', population: 55398 },
  { name: 'Ílhavo', slug: 'ilhavo', population: 38598 },
  { name: 'Vagos', slug: 'vagos', population: 22851 },
  { name: 'Sever do Vouga', slug: 'sever-do-vouga', population: 12617 },
  { name: 'Águeda', slug: 'agueda', population: 47729 },
  { name: 'Anadia', slug: 'anadia', population: 29150 },
  { name: 'Oliveira do Bairro', slug: 'oliveira-do-bairro', population: 23028 },
  { name: 'Mealhada', slug: 'mealhada', population: 20428 },
  { name: 'Cantanhede', slug: 'cantanhede', population: 36595 },
  { name: 'Mira', slug: 'mira', population: 12465 },
  { name: 'Montemor-o-Velho', slug: 'montemor-o-velho', population: 26171 },
  { name: 'Soure', slug: 'soure', population: 19245 },
  { name: 'Condeixa-a-Nova', slug: 'condeixa-a-nova', population: 17078 },
  { name: 'Penacova', slug: 'penacova', population: 15251 },
  { name: 'Lousã', slug: 'lousa', population: 17604 },
  { name: 'Miranda do Corvo', slug: 'miranda-do-corvo', population: 13069 },
  { name: 'Góis', slug: 'gois', population: 4260 },
  { name: 'Arganil', slug: 'arganil', population: 12145 },
  { name: 'Pampilhosa da Serra', slug: 'pampilhosa-da-serra', population: 4235 },
  { name: 'Oliveira do Hospital', slug: 'oliveira-do-hospital', population: 20506 },
  { name: 'Tábua', slug: 'tabua', population: 12071 },
  { name: 'Mortágua', slug: 'mortagua', population: 9607 },
  { name: 'Santa Comba Dão', slug: 'santa-comba-dao', population: 12115 },
  { name: 'Penalva do Castelo', slug: 'penalva-do-castelo', population: 7956 },
  { name: 'Carregal do Sal', slug: 'carregal-do-sal', population: 9981 },
  { name: 'Nelas', slug: 'nelas', population: 14037 },
  { name: 'Mangualde', slug: 'mangualde', population: 19880 },
  { name: 'Gouveia', slug: 'gouveia', population: 14046 },
  { name: 'Seia', slug: 'seia', population: 24702 },
  { name: 'Manteigas', slug: 'manteigas', population: 3430 },
  { name: 'Fornos de Algodres', slug: 'fornos-de-algodres', population: 4989 }
];

export const portugalExpanded = {
  code: 'PT',
  name: 'Portugal',
  slug: 'portugal',
  population: 10305564,
  topCities: [
    { name: 'Lisbon', slug: 'lisbon', population: 506654 },
    { name: 'Porto', slug: 'porto', population: 237591 },
    { name: 'Amadora', slug: 'amadora', population: 175872 },
    { name: 'Braga', slug: 'braga', population: 193333 },
    { name: 'Setúbal', slug: 'setubal', population: 117110 },
    { name: 'Coimbra', slug: 'coimbra', population: 143396 },
    { name: 'Queluz', slug: 'queluz', population: 103399 },
    { name: 'Funchal', slug: 'funchal', population: 105795 },
    { name: 'Cacém', slug: 'cacem', population: 93982 },
    { name: 'Vila Nova de Famalicão', slug: 'vila-nova-de-famalicao', population: 133832 },
    ...portugalAdditionalCities
  ]
};
